module.exports = __webpack_public_path__ + "img/translation.e32ca2c2.webp";